import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import AppBar from "@mui/material/AppBar";
import {
  CardContent,
  Toolbar,
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  Divider,
  TextField,
} from "@mui/material";
import SearchBox from "../../common/components/SearchBox";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ReactPaginate from "react-paginate";
import moment from "moment";
import { useTheme } from "@mui/material/styles";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {
  approveEmployeeJobResponsibilities,
  downloadEmployeeJobResponsibilities,
  getEmployeeJobResponsibilities,
} from "../../../store/structure/actions";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
const EmployeeJobResponsibility = (props) => {
  const {
    employeeJobResponsibilities,
    getEmployeeJobResponsibilities,
    loading,
    env,
    approveEmployeeJobResponsibilities,
    downloadEmployeeJobResponsibilities,
    user,
  } = props;
  const [value, setValue] = useState(0);
  const [searchTeam, setSearchTeam] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [
    filteredEmployeeJobResponsibilities,
    setFilteredEmployeeJobResponsibilities,
  ] = useState([...employeeJobResponsibilities]);
  const theme = useTheme();

  useEffect(() => {
    getEmployeeJobResponsibilities();
  }, []);

  useEffect(() => {
    const filtered = [...employeeJobResponsibilities].filter(({ names }) =>
      (names || "").toLowerCase().includes(searchTeam.toLowerCase())
    );

    setFilteredEmployeeJobResponsibilities(filtered);
    paginate(filtered);
  }, [searchTeam, employeeJobResponsibilities]);

  //PAGINATION
  const [paginatedItems, setPaginatedItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };
  useEffect(() => {
    paginate(filteredEmployeeJobResponsibilities);
  }, [
    itemOffset,
    itemsPerPage,
    employeeJobResponsibilities,
    filteredEmployeeJobResponsibilities,
  ]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) %
        filteredEmployeeJobResponsibilities.length || 0;

    setItemOffset(newOffset);
  };

  const onSearch = (term) => {
    setSearchTeam(term);
  };
  return (
    <>
      <Box sx={{ display: "flex", width: "100%" }}>
        <div className="w-100">
          <AppBar position="static" elevation={0} className="app-bar w-100">
            <Toolbar>
              <Typography
                variant="h6"
                noWrap
                component="div"
                // sx={{ display: { xs: "none", sm: "block" } }}
              >
                <span>STRUCTURE</span>
                <span className="mr-1 ml-1" style={{ color: "#2a7790" }}>
                  <span
                    className="material-icons  text-dark"
                    style={{ position: "relative", top: "4px" }}
                  >
                    chevron_right
                  </span>
                </span>

                <span style={{ color: "rgb(7, 142, 206)" }}>
                  <span style={{ color: "rgb(7, 142, 206)" }}>
                    Job Responsibilities
                  </span>
                </span>
              </Typography>

              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                <SearchBox
                  disabled={!employeeJobResponsibilities.length}
                  onSearch={onSearch}
                  placeholder="Search…"
                />
                <Button
                  onClick={handleOpenMenu}
                  variant="contained"
                  size="small"
                  disableElevation
                  className="mx-2 px-4"
                >
                  <span className="material-icons mr-1">cloud_download</span>
                  Download
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={open}
                  onClose={handleCloseMenu}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "auto",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 2,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 15,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{
                    horizontal: "right",
                    vertical: "top",
                  }}
                  anchorOrigin={{
                    horizontal: "right",
                    vertical: "bottom",
                  }}
                >
                  <span>
                    <MenuItem
                      onClick={() => {
                        handleCloseMenu();
                        downloadEmployeeJobResponsibilities(
                          "List of employees filled JobResponsibilities",
                          "filled",
                          setIsDownloading
                        );
                      }}
                      className="font-weight-bold text-success"
                    >
                      {isDownloading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm mr-2"
                            role="status"
                            style={{ fontSize: "28px" }}
                          ></span>

                          <span className="sr-only">Loading...</span>
                        </>
                      ) : (
                        <span
                          className="material-icons mr-2"
                          style={{ fontSize: "28px" }}
                        >
                          cloud_download
                        </span>
                      )}
                      Filled JobResponsibilities
                    </MenuItem>
                    <Divider className="my-1" />
                    <MenuItem
                      onClick={() => {
                        handleCloseMenu();
                        downloadEmployeeJobResponsibilities(
                          "List of employees unfilled Job Responsibilities",
                          "un-filled",
                          setIsDownloading
                        );
                      }}
                      className="font-weight-bold text-danger"
                    >
                      {isDownloading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm mr-2"
                            role="status"
                            style={{ fontSize: "28px" }}
                          ></span>

                          <span className="sr-only">Loading...</span>
                        </>
                      ) : (
                        <span
                          className="material-icons mr-2"
                          style={{ fontSize: "28px" }}
                        >
                          cloud_download
                        </span>
                      )}
                      Unfilled JobResponsibilities
                    </MenuItem>
                  </span>
                </Menu>
              </Box>
            </Toolbar>
          </AppBar>

          <div
            style={{
              padding: theme.spacing(0.4),
              height: "auto",
              maxHeight: "auto",
              margin: "1.2em",
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              overflow: "visible",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
            }}
          >
            <CardContent
              style={{
                padding: ".1em",
                height: "auto",
                minHeight: "auto",
                overflow: "auto",
              }}
            >
              {!!paginatedItems && !!paginatedItems.length && (
                <table className="table table-striped table-hover table-sm  fixTableHead">
                  <thead>
                    <tr style={{ backgroundColor: "#f0f2f5" }}>
                      <th scope="col">EmployeeId</th>
                      <th scope="col">Employee Names</th>
                      <th scope="col">Employee Position</th>
                      <th scope="col">Submitted On</th>
                      <th scope="col" className="text-right">
                        Status
                      </th>
                      <th scope="col"></th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedItems.map((jobResponsibility, index) => (
                      <RequestItem
                        key={index}
                        jobResponsibility={jobResponsibility}
                        index={index}
                        env={env}
                        user={user}
                        approveEmployeeJobResponsibilities={
                          approveEmployeeJobResponsibilities
                        }
                      />
                    ))}
                  </tbody>
                </table>
              )}

              <div
                className="justify-content-center"
                style={{ overflow: "hidden" }}
              >
                {!loading &&
                  !!paginatedItems.length &&
                  employeeJobResponsibilities.length >= itemsPerPage && (
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel={
                        <>
                          <span className="pr-1 d-none d-md-inline">Next</span>
                          <i className="fas fa-angle-double-right"></i>
                        </>
                      }
                      previousLabel={
                        <>
                          <i className="fas fa-angle-double-left"></i>
                          <span className="pl-1  d-none d-md-inline">
                            Previous
                          </span>
                        </>
                      }
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      onPageChange={handlePageClick}
                      pageCount={pageCount}
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1 mt-1"
                      previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1 mt-1"
                      nextLinkClassName="btn btn-outline-info btn-sm ml-1 mt-1"
                      activeLinkClassName="active"
                    />
                  )}
              </div>

              {!employeeJobResponsibilities.length && !loading && (
                <div className="text-center">
                  <p className="lead">No Request found</p>
                </div>
              )}

              {loading && !employeeJobResponsibilities.length && (
                <div className="text-center">
                  {/* <img src={loadingGif} height="128" alt="loading" /> */}
                </div>
              )}
            </CardContent>
          </div>
        </div>
      </Box>
    </>
  );
};

const mapStateToProps = ({
  env,
  user,
  loading,
  employeeJobResponsibilities,
}) => {
  return { env, user, loading, employeeJobResponsibilities };
};
export default connect(mapStateToProps, {
  getEmployeeJobResponsibilities,
  approveEmployeeJobResponsibilities,
  downloadEmployeeJobResponsibilities,
})(EmployeeJobResponsibility);

const RequestItem = (props) => {
  const {
    loading,
    jobResponsibility,
    env,
    user,
    approveEmployeeJobResponsibilities,
  } = props;
  const { hasPermissions } = useRequiredAuth();
  const [reason, setReason] = useState("");
  const [hoveredRequest, setHoveredRequest] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  return (
    <>
      <tr
        key={jobResponsibility.id}
        onMouseEnter={() => setHoveredRequest(jobResponsibility)}
        onFocus={() => setHoveredRequest(jobResponsibility)}
        onBlur={() => setHoveredRequest(null)}
        onMouseLeave={() => setHoveredRequest(null)}
        style={{
          backgroundColor:
            hoveredRequest === jobResponsibility ? `#cdeef8!important` : "",
          border:
            hoveredRequest === jobResponsibility ? "2px solid #376fc8" : "none",
          cursor: hoveredRequest === jobResponsibility ? "pointer" : "",
          boxShadow:
            hoveredRequest === jobResponsibility
              ? "inset 0px 0px 0px 1px transparent"
              : "",
        }}
      >
        <td>{jobResponsibility.employeeId}</td>

        <td>{jobResponsibility.names}</td>
        <td>{jobResponsibility.positionName}</td>
        <td>{moment(jobResponsibility.createdOn).format("LLL")}</td>
        <td className="text-right">
          {+jobResponsibility.isApproved === 0 && (
            <span className={`badge badge-primary`}>Awaiting for Approval</span>
          )}
          {+jobResponsibility.isApproved === 1 && (
            <>
              <span className={`badge badge-success mr-1`}>Approved</span>
              {/* by {jobResponsibility.approvedNames} */}
            </>
          )}
          {+jobResponsibility.isApproved === 2 && (
            <>
              <span className={`badge badge-danger mr-1`}>Declined</span>
              {/* by {jobResponsibility.approvedNames} */}
            </>
          )}
        </td>
        <td className="text-right">
          <>
            <button
              onClick={() => setShowModal(true)}
              type="button"
              disabled={loading}
              className={`m-2 btn btn-${
                [0, 2].includes(+jobResponsibility.isApproved)
                  ? "primary"
                  : "success"
              }`}
            >
              {[0, 2].includes(+jobResponsibility.isApproved) &&
              hasPermissions(["IS_HEAD_OF_UNIT"]) &&
              (user?.selectedEntitySector?.entityId || "") ===
                "2000000000-010200000000000000" ? (
                <>
                  <TaskAltIcon />
                  {+jobResponsibility.isApproved === 2 && "Re-"}approve?
                </>
              ) : (
                <>
                  <OpenInNewIcon /> Open
                </>
              )}
            </button>
          </>
        </td>
      </tr>

      {showModal && (
        <ConfirmationDialog
          size="xl"
          alignContent="left"
          dividers
          canRemoveDialogAction={
            +jobResponsibility.isApproved === 1 ||
            !(
              hasPermissions(["IS_HEAD_OF_UNIT"]) &&
              (user?.selectedEntitySector?.entityId || "") ===
                "2000000000-010200000000000000"
            )
          }
          title={
            <>
              <div className="pr-5">
                <span className="text-dark">
                  View {jobResponsibility.names}'s Job Responsibility
                </span>
                {+jobResponsibility.isApproved === 0 && (
                  <span className={`badge badge-primary ml-2`}>
                    Awaiting for Approval
                  </span>
                )}
                {+jobResponsibility.isApproved === 1 && (
                  <span className={`badge badge-success ml-2`}>Approved</span>
                )}
                {+jobResponsibility.isApproved === 2 && (
                  <span className={`badge badge-danger ml-2`}>Declined</span>
                )}
              </div>
            </>
          }
          confirmationDialog={showModal}
          message={
            <>
              {jobResponsibility.jobResponsibilities}
              <p>
                <table className="mt-5">
                  {jobResponsibility.reason && (
                    <tr className={`border border-primary`}>
                      <th scope="row">Reason</th>
                      <td>{jobResponsibility.reason}</td>
                    </tr>
                  )}
                </table>
              </p>
            </>
          }
          setConfirmationDialog={setShowModal}
          onYes={() => {
            setShowStatusModal(1);
            setShowConfirmModal(true);
            // approveEmployeeJobResponsibilities(jobResponsibility, setShowModal);
          }}
          onDecline={() => {
            setShowStatusModal(2);
            setShowConfirmModal(true);
            // approveEmployeeJobResponsibilities(jobResponsibility, setShowModal);
          }}
        />
      )}

      {showConfirmModal && (
        <ConfirmationDialog
          disabled={!reason}
          confirmationDialog={showConfirmModal}
          message={
            <>
              <p>
                Are you sure you want to{" "}
                {+showStatusModal === 1 ? (
                  <>
                    <strong className="text-success">approve</strong>
                  </>
                ) : (
                  <>
                    <strong className="text-danger">decline</strong>
                  </>
                )}{" "}
                this job responsibilities?
              </p>
              <TextField
                fullWidth
                size="small"
                multiline
                rows={4}
                name="Reason"
                label="Type your reason .."
                variant="outlined"
                placeholder="Type your reason  .."
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value || "");
                }}
              />
            </>
          }
          setConfirmationDialog={setShowConfirmModal}
          onYes={() => {
            const params = {
              statusId: showStatusModal,
              email: jobResponsibility.email,
              names: jobResponsibility.names,
              // hrEmail: jobResponsibility.hrEmail,
              reason: reason,
            };
            approveEmployeeJobResponsibilities(
              jobResponsibility,
              params,
              setShowModal,
              setShowConfirmModal
            );
          }}
        />
      )}
    </>
  );
};
